import { ScrollTop } from 'primereact/scrolltop';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import MeetingRoomOutlook from './MeetingRoomOutlook';
import './MeetingRoomOutlookUsage.less';

// Import Block 6-10 Analysis Charts
import {
  ReservationUsageChart,
  UnusedReleasedTimeChart,
  UnusedOrganizersChart,
  PeopleRateChart,
} from './MeetingRoomAnalysisCharts';

@connect(state => ({
  querystring: state.querystring,
}))
class MeetingRoomOutlookUsage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      barChartType: 'weekly', //[weekly, monthly]
      selectedDate: null,
      leftTimelineHeight: null,
    };
    this.handleBarChartTypeChange = this.handleBarChartTypeChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.leftTimelineRef = React.createRef();
  }

  componentDidMount() {
    // Add window resize listener for dynamic adjustments
    window.addEventListener('resize', this.handleResize);
    
    // Set up observer and polling after a short delay to ensure refs are set
    setTimeout(() => {
      this.setupResizeObserver();
      this.startHeightPolling();
    }, 10);
  }

  componentDidUpdate(prevProps, prevState) {
    // Measure heights whenever selectedDate changes
    if (prevState.selectedDate !== this.state.selectedDate) {
      this.startHeightPolling();
    }
  }

  componentWillUnmount() {
    // Clean up event listeners and observers
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  }

  setupResizeObserver = () => {
    if (window.ResizeObserver && this.leftTimelineRef.current) {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const height = entry.contentRect.height;
          if (height > 0 && height !== this.state.leftTimelineHeight) {
            this.setState({ leftTimelineHeight: height });
          }
        }
      });
      
      this.resizeObserver.observe(this.leftTimelineRef.current);
    } else {
      // Fallback for browsers without ResizeObserver
      if (window.MutationObserver && this.leftTimelineRef.current) {
        this.mutationObserver = new MutationObserver(() => {
          this.measureHeights();
        });
        
        this.mutationObserver.observe(this.leftTimelineRef.current, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
      }
    }
  };

  startHeightPolling = () => {
    // Clear any existing polling
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
    
    let attempts = 0;
    const maxAttempts = 50; // Poll for 5 seconds max
    
    this.pollingInterval = setInterval(() => {
      attempts++;
      const measured = this.measureHeights();
      
      // Stop polling if we got a good height or reached max attempts
      if (measured || attempts >= maxAttempts) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    }, 100);
  };

  handleResize = () => {
    // Debounce resize events
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => this.measureHeights(), 200);
  };

  measureHeights = () => {
    if (this.leftTimelineRef.current) {
      const leftHeight = this.leftTimelineRef.current.offsetHeight;
      if (leftHeight > 100 && leftHeight !== this.state.leftTimelineHeight) {
        this.setState({ leftTimelineHeight: leftHeight });
        return true; // Successfully measured
      }
    }
    return false; // Failed to measure
  };

  // Callback for when left timeline finishes loading
  handleTimelineLoaded = () => {
    setTimeout(() => this.measureHeights(), 50);
  };

  handleBarChartTypeChange = value => {
    this.setState({ barChartType: value });
  };

  handleDateChange = value => {
    this.setState({ selectedDate: value });
  };

  render() {
    return (
      <div className="meeting-room-outlook-usage figma-design">
        {/* Main Content - Full Width Timeline (Usage Analysis section removed per Block 5) */}
        <div className="main-content">
          {/* Full Width: Timeline View (予約状況) */}
          <div className="timeline-section-wrapper full-width" ref={this.leftTimelineRef}>
            <MeetingRoomOutlook 
              onDateChanged={this.handleDateChange}
              onLoadComplete={this.handleTimelineLoaded}
            />
          </div>
        </div>

        {/* Block 6-10: Meeting Room Analysis Charts */}
        <div className="analysis-charts-section">
          {/* Block 6: Reservation and Usage Time */}
          <ReservationUsageChart />

          {/* Block 7 & 8: Unused and Released Time - Side by side sections */}
          <div className="unused-time-row">
            <UnusedReleasedTimeChart />
            <UnusedOrganizersChart />
          </div>

          {/* Block 9 & 10: People Rate Distribution (combined section) */}
          <PeopleRateChart />
        </div>

        <ScrollTop
          target="parent"
          threshold={400}
          className=""
          style={{
            height: 40,
            width: 40,
          }}
        />
      </div>
    );
  }
}

MeetingRoomOutlookUsage.propTypes = {};

export default MeetingRoomOutlookUsage;
